import {
  connect,
} from 'react-redux';
import {
  withTranslation,
} from 'react-i18next';

import {
  actions as authActions,
} from '../../../redux/modules/auth';
import {
  actions as mainActions,
} from '../../../redux/modules/main';

import RegattaProtestDialogView from './RegattaProtestDialogView';

// Types
import type {
  $State,
} from '../../../redux';
import type {
  $DispatchProps,
  $OwnProps,
  $StateProps,
} from './RegattaProtestDialogView';

const mapStateToProps = ({
  auth,
}: $State): $StateProps => ({
  auth,
});

const mapDispatchToProps = (dispatchAction): $DispatchProps => ({
  authenticate: (params) => dispatchAction(
    authActions.authenticate(params),
  ),
  setupUser: (params) => dispatchAction(
    mainActions.setupUser(params),
  ),
});

const ConnectedComponent = connect<
$StateProps,
$DispatchProps,
$OwnProps,
$State
>(
  mapStateToProps,
  mapDispatchToProps,
)(RegattaProtestDialogView);

const TranslatedComponent = withTranslation()(ConnectedComponent);

const Component = TranslatedComponent;

export default Component;
